export function extractSubdomain(rawUrl: string): string | null {
	try {
		const parsed = new URL(rawUrl);
		const { hostname } = parsed;
		const parts = hostname.split('.');

		if (parts.length >= 3 && parts.slice(-2).join('.') === 'liftapp.ai') {
			const prefix = parts.slice(0, -2).join('.');
			return prefix || null;
		}

		return null;
	} catch {
		return null;
	}
}
